import { createFileRoute } from '@tanstack/react-router'
import { TicketDetailView } from '@/features/ticket-detail/TicketDetailView'

function UserDetail() {
  const { id } = Route.useParams()
  const { asUser } = Route.useSearch()
  return <TicketDetailView ticketId={id} asUser={asUser} />
}

export const Route = createFileRoute('/tickets/$id')({
  // Keeps the lens active when clicking through from a lensed inbox.
  validateSearch: (raw: Record<string, unknown>): { asUser?: string } => ({
    asUser: typeof raw.asUser === 'string' && raw.asUser ? raw.asUser : undefined,
  }),
  component: UserDetail,
})
